import _ from 'lodash'

export function getXmlEscaper() {
  var doc = document.implementation.createDocument('', '', null)
  var el = doc.createElement('temp')
  el.textContent = 'temp'
  el = el.firstChild
  var ser = new XMLSerializer()
  return function(text) {
    el.nodeValue = text
    return ser.serializeToString(el)
  }
}

export function reintroduceBackslashes(text) {
  if (!text) return text
  return text.replace(/\n/g, '\\n').replace(/\t/g, '\\t')
}

export function getChosenPropsMutationXml(code, propertyNodes, walk, omittedPropNames = []) {
  let props = propertyNodes.filter(p => !_.includes(omittedPropNames, p.key.name || p.key.value))
  let propNames = props.map(p => p.key.name || p.key.value) // Identifier or literal
  let propElements = props.map(p => {
    return `<value name="${p.key.name || p.key.value}">${walk.expr(code, p.value)}</value>`
  })
  return {
    mutationElt:
      propNames.length > 0 ? `<mutation chosenprops="${propNames.join(',')}"></mutation>` : '',
    propElts: propElements,
    propNames
  }
}
